<template>
  <div class="products-page">
    <app-page-header title="Produtos">
      <button @click="importProducts()" v-app-button.icon-left>
        <b-icon size="is-small" icon="upload"></b-icon>IMPORTAR
      </button>
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus" />NOVO
      </button>
    </app-page-header>

    <products-table ref="productsTable"></products-table>

    <b-modal
      :active.sync="showModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <product-import-modal @success="onImportSuccess"></product-import-modal>
    </b-modal>
  </div>
</template>

<script>
import ProductImportModal from '@/components/Modals/ProductImportModal.vue';
import ProductsTable from '@/components/Tables/ProductsTable.vue';

export default {
  name: 'products-page',
  components: {
    ProductsTable,
    ProductImportModal,
  },
  data: () => {
    return {
      showModal: false,
    };
  },
  methods: {
    create() {
      this.$router.push('/products/create');
    },
    importProducts() {
      this.showModal = true;
    },
    onImportSuccess() {
      this.$refs.productsTable.load();
    },
  },
};
</script>

<style lang="scss" scoped></style>
